/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAnalyticsResumeResponse } from '../../models/get-analytics-resume-response';

export interface GetAnalyticsResume$Params {
}

export function getAnalyticsResume(http: HttpClient, rootUrl: string, params?: GetAnalyticsResume$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAnalyticsResumeResponse>> {
  const rb = new RequestBuilder(rootUrl, getAnalyticsResume.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAnalyticsResumeResponse>;
    })
  );
}

getAnalyticsResume.PATH = '/api/user/analytics/analytics-resume';
